<template>
  <view-wrap class="bg-light">
    <div id="about">
      <h1 class="caps">Contact Us</h1>
      <p>If you have any feedback or suggestions, please do reach out!</p>
      <p>Send and email to <strong>contact@fantasyfalcon.com</strong> or tweet at us <a :href="external.twitter" target="_blank">@fantasytoolbox</a></p>
    </div>
  </view-wrap>
</template>

<script>
  export default {
    name: "contact",
    data () {
      return {}
    },
    components: {},
    methods: {}
  };
</script>

<style src="./contact.styl" lang="stylus" scoped></style>
